export const getAllowedDistributionProductIds = ({
  products = [],
  isBat,
  batProducts,
  customerId,
}) => {
  const distributionProductIds = new Set(
    products.map(({ id }) => String(id)),
  );

  if (!isBat || !batProducts || !customerId) {
    return distributionProductIds;
  }

  const customerBatProductIds = new Set(
    (batProducts[String(customerId)] || []).map(String),
  );

  return new Set(
    [...distributionProductIds].filter((productId) =>
      customerBatProductIds.has(productId),
    ),
  );
};

export const filterDistributionSelections = (
  selections,
  allowedProductIds,
) =>
  Object.fromEntries(
    Object.entries(selections || {}).filter(([productId]) =>
      allowedProductIds.has(String(productId)),
    ),
  );

export const sanitizeSurveyDistributionAnswers = ({
  variables,
  survey,
  batProducts,
}) => {
  if (!survey || !variables?.input?.answers) return variables;

  const customerId = variables.input.customer;
  const answers = variables.input.answers.map((answer) => {
    if (!answer.distributionSelections) return answer;

    const question = (survey.questions || []).find(
      ({ id }) => String(id) === String(answer.questionId),
    );
    if (!question) return answer;

    let selections;
    try {
      selections = JSON.parse(answer.distributionSelections);
    } catch (_) {
      return answer;
    }

    const allowedProductIds = getAllowedDistributionProductIds({
      products: question.products,
      isBat: survey.bat === 'D',
      batProducts,
      customerId,
    });

    return {
      ...answer,
      distributionSelections: JSON.stringify(
        filterDistributionSelections(selections, allowedProductIds),
      ),
    };
  });

  return {
    ...variables,
    input: {
      ...variables.input,
      answers,
    },
  };
};
